import { createSlice } from '@reduxjs/toolkit';

const EmergencyCenterSlice = createSlice({
  name: 'EmergencyCenterSlice',
  initialState: {
    isLoading: false,
    listData: { list: [], total: 0, limit: 10 },
    isError: null,
    details: null,
  },
  reducers: {
    // List
    requestEmergencyCenterList: (state) => ({ ...state, isLoading: true }),
    responseEmergencyCenterList: (state, action) => ({
      ...state,
      isLoading: false,
      listData: action?.payload?.data || { list: [], total: 0, limit: 10 },
    }),
    failureEmergencyCenterList: (state, action) => ({
      ...state,
      isLoading: false,
      isError: action?.payload,
    }),

    // Details (optional)
    requestEmergencyCenterView: (state) => ({ ...state, isLoading: true }),
    responseEmergencyCenterView: (state, action) => ({
      ...state,
      isLoading: false,
      details: action?.payload,
    }),
    failureEmergencyCenterView: (state, action) => ({
      ...state,
      isLoading: false,
      isError: action?.payload,
    }),
  },
});

export const {
  requestEmergencyCenterList,
  responseEmergencyCenterList,
  failureEmergencyCenterList,
  requestEmergencyCenterView,
  responseEmergencyCenterView,
  failureEmergencyCenterView,
} = EmergencyCenterSlice.actions;

export default EmergencyCenterSlice.reducer;
